import { TourProvider } from '@reactour/tour'
import { type ReactNode } from 'react'

const popoverStyles = {
  popover: (base: Record<string, unknown>) => ({
    ...base,
    borderRadius: '10px',
    padding: '0',
    boxShadow:
      '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
    maxWidth: '380px',
    zIndex: 100001,
  }),
  maskArea: (base: Record<string, unknown>) => ({
    ...base,
    rx: 8,
  }),
  maskWrapper: (base: Record<string, unknown>) => ({
    ...base,
    zIndex: 100000,
  }),
  badge: () => ({ display: 'none' }),
  controls: () => ({ display: 'none' }),
}

interface GuidedTourProviderProps {
  children: ReactNode
}

export function GuidedTourProvider({ children }: GuidedTourProviderProps) {
  return (
    <TourProvider
      steps={[]}
      styles={popoverStyles}
      padding={{ mask: 8, popover: 10 }}
      showBadge={false}
      showNavigation={false}
      disableInteraction
    >
      {children}
    </TourProvider>
  )
}
